import React, { useState, useEffect } from "react";
import cx from "classnames";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Fade,
} from "reactstrap";
import { v4 } from "uuid";
import { ToastContainer } from "react-toastify";

// styles
import styles from "./OrderStatusUpdateButton.module.scss";

//interfaces
import { IOrderStatus, IPartnerOrder } from "../../../interfaces/order";

//api
import apis from "../../../api/apis";
import {
  orderRequestModel,
  statusForBtnsRequestModel,
} from "../../../api/apiRequestObjects";

//config
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import orderStatus from "../../../config/orderStatus";
import {
  notifyError,
  notifyServerError,
  notifyStatusUpdateError,
} from "../../../config/toastNotification";

//component
import LoadingComponent from "../../loadingComponent/LoadingComponent";
import CancelRejectReasonDialog from "../cancelRejectReasonsDialog/cancelRejectReasonDialog";
import { useSelector } from "react-redux";
import moment from "moment";
import printJS from "print-js";
import { SnackBarModel } from "../../snackBar/SnackBar";

//manual close button for toast notifications
const CloseButton = ({ closeToast }: any) => (
  <i
    className="material-icons"
    onClick={closeToast && window.location.reload()}
  ></i>
);

interface IProps {
  classNames?: string;
  statusForBtn: IOrderStatus[];
  posOrderStatus: IOrderStatus[];
  selectedOrder: IPartnerOrder;
  partnerOrderId?: number | undefined;

  updateOrder: (
    updatedOrderStatus: IOrderStatus,
    selectedOrder: IPartnerOrder
  ) => void;
}

const OrderStatusUpdateButton: React.FC<IProps> = ({
  classNames,
  statusForBtn,
  selectedOrder,
  updateOrder,
  posOrderStatus,
}) => {
  // console.log(selectedOrder);
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(false);
  const [isIncomingOrderTimeOut, setIsIncomingOrderTimeOut] = useState(false);
  const [latestUpdatedStatus, setLatestUpdatedStatus] = useState("");
  const [isUpdatingAndLoading, setIsUpdatingAndLoading] = useState(false);
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const [reasonStateKey, setReasonStateKey] = useState<number>(0);
  const [isReasonForReject, setIsReasonForReject] = useState(false);
  const [selectedReasonCode, setSelectedReasonCode] = useState<string>("");
  const [selectedReasonKey, setSelectedReasonKey] = useState<number>(1);

  //new
  const [partnerOrder, setPartnerOrder] = useState<IPartnerOrder>();
  const [snackBarmodel, setSnackBarModel] = useState<SnackBarModel>({
    openSnackBar: false,
    msg: "",
    autoHideDuration: 6000,
  });
  const [isOrderDetailsLoading, setIsOrderDetailsLoading] = useState(false);

  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  useEffect(() => {
    const fetchData = async () => {
      try {
        //setIsOrderDetailsLoading(true);
        orderRequestModel.UID.UserKey = user.UserKey;
        orderRequestModel.UID.LocationKey = user.LocationKey;
        orderRequestModel.UID.CompanyKey = user.CompanyKey;
        orderRequestModel.UID.EnvironmentName = user.EnvironmentName;

        orderRequestModel.PartnerOrderId = selectedOrder.PartnerOrderId;
        const response = await apis.Orders.fetchPartnerOrder(orderRequestModel);
        //console.log(response);
        if (response.ResponseType === APIResponseType.Success) {
          //console.log(response.ResponseData.AllOrders);
          setPartnerOrder(response.ResponseData.PartnerOrder);
          //console.log(setOrderList(response.ResponseData.AllOrders));
          setIsOrderDetailsLoading(false);
          // console.log(partnerOrder);
          //console.log(selectedItem);
        } else {
          console.log("api fetching error");
          setIsOrderDetailsLoading(false);
        }
      } catch (e) {
        notifyError();
        console.log(e);
      }
    };

    fetchData();
  }, [selectedOrder]);

  //handling reason selecting and set the reason code in state
  const handleRadioBtnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedReasonCode((event.target as HTMLInputElement).value);
    setSelectedReasonKey(parseInt((event.target as HTMLInputElement).name));
  };

  //handle reason dialog ok button
  const handleClickOKReasonDialog = (orderStatesKey: number) => {
    if (isReasonForReject) {
      statusForBtn &&
        statusForBtn.map((OrderStatus) => {
          if (OrderStatus.POSStatusKey === orderStatesKey) {
            setOrderStatusUpdate(OrderStatus, selectedOrder);
          }
        });
      setOpenReasonDialog(false);
    } else {
      statusForBtn &&
        statusForBtn.map((OrderStatus) => {
          if (OrderStatus.POSStatusKey === orderStatesKey) {
            setOrderStatusUpdate(OrderStatus, selectedOrder);
          }
        });
      setOpenReasonDialog(false);
    }
  };

  //handle dialog close
  const handleDialogClose = () => {
    setOpenReasonDialog(false);
    setSelectedReasonCode("");
  };

  //handle drop down list for filter reject and cancel status for reasoning
  const handleDropDownList = (
    orderState: IOrderStatus,
    selectedOrder: IPartnerOrder
  ) => {
    if (orderState.IsShowVoidReasons) {
      //cancel & reject
      //console.log("orderstatusKey", orderState.POSStatusKey);
      //console.log(orderState.IsShowVoidReasons);
      setReasonStateKey(orderState.POSStatusKey);
      setIsReasonForReject(true);
      //setSelectedReasonCode("STORE_CLOSED");
      setOpenReasonDialog(true);
      /*     } else if (orderState.POSStatusCode === orderStatus.cancelled) {
      setReasonStateKey(orderState.POSStatusKey);
      setIsReasonForReject(false);
      setSelectedReasonCode("OUT_OF_ITEMS");
      setOpenReasonDialog(true); */
    } else {
      setOpenReasonDialog(false);
      setIsReasonForReject(false);
      setOrderStatusUpdate(orderState, selectedOrder);
    }
  };

  //KOT when confirmed
  const handleKOTPrint = async (KOTReportSource: string | undefined) => {
    //Build a URL from the file
    //  console.log("inside KOT");
    if (KOTReportSource !== undefined) {
      //console.log(KOTReportSource);
      //const res = await window.fetch(KOTReportSource);
      //const base64 = await fetch(KOTReportSource);
      try {
        const base64Response = await fetch(
          `data:application/pdf;base64,${KOTReportSource}`
        );
        const blob = await base64Response.blob();
        //const blob = await res.blob();
        const fileURL = URL.createObjectURL(blob);
        //console.log(b64toBlob(KOTReportSource));
        printJS(fileURL);
      } catch (e) {
        console.log("fetch error", e);
        //show error msg
        setSnackBarModel({
          openSnackBar: true,
          msg: "Error: Report Source Not Found !",
          autoHideDuration: 6000,
        });
      }
    } else {
      //show error msg
      setSnackBarModel({
        openSnackBar: true,
        msg: "Error: Report Source Not Found !",
        autoHideDuration: 6000,
      });
    }
  };

  //update order status through api
  const setOrderStatusUpdate = async (
    updatingOrderStatus: IOrderStatus,
    selectedOrder: IPartnerOrder
  ) => {
    console.log("CLICKED");
    // window.print();
     //window.location.reload();
    try {
      setIsUpdatingAndLoading(true);

      //incoming order timeout check
      if (
        selectedOrder.OrderDelivery.OrderStatus.POSStatusCode ===
          posOrderStatus[0].POSStatusCode &&
        moment(moment.now()).isSameOrAfter(
          moment(selectedOrder.OrderDate).add(10.5, "minutes")
        )
      ) {
        updatingOrderStatus.POSStatusKey = statusForBtn[1].POSStatusKey;
        updatingOrderStatus.POSStatusCode = statusForBtn[1].POSStatusCode;
        setSelectedReasonCode("TimeOut");
        setIsIncomingOrderTimeOut(true);
        //notifyStatusUpdateError();
      }

      //order status updating
      statusForBtnsRequestModel.UID.UserKey = user.UserKey;
      statusForBtnsRequestModel.UID.LocationKey = user.LocationKey;
      statusForBtnsRequestModel.UID.CompanyKey = user.CompanyKey;
      statusForBtnsRequestModel.UID.EnvironmentName = user.EnvironmentName;

      statusForBtnsRequestModel.POSStatusKey = updatingOrderStatus.POSStatusKey;
      statusForBtnsRequestModel.PartnerOrderId = selectedOrder.PartnerOrderId;
      statusForBtnsRequestModel.OrderId = selectedOrder.OrderId;
      statusForBtnsRequestModel.OrderTypeKey =
        selectedOrder.OrderDelivery.TypeOfOrder.OrderTypeId;
      statusForBtnsRequestModel.CurrentPOSStatusCode =
        selectedOrder.OrderDelivery.OrderStatus.POSStatusCode;
      statusForBtnsRequestModel.DenyOrCancelReasonCode = selectedReasonCode;
      statusForBtnsRequestModel.DenyOrCancelReasonKey = selectedReasonKey;

      //console.log(statusForBtnsRequestModel);

      const response = await apis.Orders.updateOrderStatus(
        statusForBtnsRequestModel
      );

      if (response.ResponseType === APIResponseType.Success) {
        setIsUpdateSuccess(true);
        setLatestUpdatedStatus(updatingOrderStatus.POSStatusCode);
        // window.alert(updatingOrderStatus.POSStatusCode);
        if (updatingOrderStatus.POSStatusCode === "Confirmed") {
          //window.alert(KOTSource);
          // window.print();
          await handleKOTPrint(partnerOrder?.KOTReportSource);
        }

        updateOrder(updatingOrderStatus, selectedOrder);
        //console.log(response);
        setIsUpdatingAndLoading(false);
        setIsIncomingOrderTimeOut(false);
        setSelectedReasonCode("");
      } else {
        setIsUpdatingAndLoading(false);
        setIsUpdateSuccess(false);
        setIsIncomingOrderTimeOut(false);
        setSelectedReasonCode("");
        notifyStatusUpdateError();
        //console.log(response);
      }
    } catch (e) {
      notifyServerError();
      console.log("Error: Order status not updated", e);
      setIsUpdatingAndLoading(false);
      setIsIncomingOrderTimeOut(false);
      setSelectedReasonCode("");
    }
  };

  if (isUpdateSuccess)
    return (
      <Fade in={isUpdateSuccess} tag="h5" className={styles.fade_msg}>
        {latestUpdatedStatus} ✅
      </Fade>
    );

  if (isIncomingOrderTimeOut)
    return (
      <Fade in={isIncomingOrderTimeOut} tag="h5" className={styles.fade_msg2}>
        Time Out 🗑
      </Fade>
    );

  if (isUpdatingAndLoading) return <LoadingComponent />;

  if (statusForBtn === null) return null;

  return (
    <div className={cx(styles.action_buttons, classNames)}>
      {statusForBtn[0] && (
        <button
          type="button"
          onClick={() => setOrderStatusUpdate(statusForBtn[0], selectedOrder)}
          className={cx(styles.action_button, classNames)}
        >
          {statusForBtn[0].POSStatusName}
        </button>
      )}
      <UncontrolledDropdown>
        <DropdownToggle className={styles.toggle_menu} caret>
          {""}
        </DropdownToggle>
        <DropdownMenu left>
          {statusForBtn &&
            statusForBtn.map(
              (orderState) =>
                orderState.POSStatusKey !== statusForBtn[0].POSStatusKey && (
                  <DropdownItem
                    onClick={() =>
                      handleDropDownList(orderState, selectedOrder)
                    }
                    key={v4()}
                    id={orderState.POSStatusCode}
                  >
                    {orderState.POSStatusName}
                  </DropdownItem>
                )
            )}
        </DropdownMenu>
      </UncontrolledDropdown>
      <CancelRejectReasonDialog
        openReasonDialog={openReasonDialog}
        reasonStateKey={reasonStateKey}
        isReasonForReject={isReasonForReject}
        selectedReasonCode={selectedReasonCode}
        selectedOrder={selectedOrder}
        handleRadioBtnChange={handleRadioBtnChange}
        handleClickOKReasonDialog={handleClickOKReasonDialog}
        handleDialogClose={handleDialogClose}
      />
      <ToastContainer
        className={styles.toast_notifier}
        closeButton={CloseButton}
      />
    </div>
  );
};

export default OrderStatusUpdateButton;
